import { useRSO } from "@/api/services/admin/rso";
import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack, Typography } from "@mui/material";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { styled } from "@mui/system";
import { black, divider } from "@/theme/colors";

export const PartnerDescription = () => {
  const { data: matchResult } = useRSO();

  const matchData = matchResult?.data;

  return (
    <MatchInnerBox>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <ItemInfo label="紹介会社情報" value={matchData?.description} type="textArea" isShowDivider={false} />
        </Grid>
        <Grid item xs={4}>
          <ItemInfo label="備考" value={matchData?.note} type="textArea" isShowDivider={false} />
        </Grid>
        <Grid item xs={4}>
          <Stack direction="row" spacing={2} justifyContent="space-around">
            <Stack direction="column" spacing={2} alignItems="center">
              <Typography variant="cap12" color={black[70]}>
                外国人数
              </Typography>
              <Typography variant="head24Bold">{matchData?.currentLearnerCount ?? 0} 人</Typography>
            </Stack>
            <Stack direction="column" spacing={2} alignItems="center">
              <Typography variant="cap12" color={black[70]}>
                有効アカウント数
              </Typography>
              <Typography variant="head24Bold">{matchData?.activeAccountLearnerCount ?? 0} 人</Typography>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </MatchInnerBox>
  );
};

const MatchInnerBox = styled(InnerBox)`
  border: 1px solid ${divider.high};
  padding: 8px;
`;
